module.exports = __webpack_public_path__ + "img/IO.f3fdc9d4.svg";